import { useMemo } from 'react';
import { useCurrentYearAssumptionsQuery } from './api/useCurrentYearAssumptionsQuery';
import { OptionDTO } from './api/responseDTO.types';
import { OptionType } from '../OPL/Select/BaseSelect/types';
import { useCurrentYearAssumptionMutation } from './api/useCurrentYearAssumptionMutation';

const normalizeOptions = (options: OptionDTO[]): OptionType<number>[] => {
  return options.map(({ description, ...option }) => ({
    ...option,
    subLabel: description,
  }));
};

export const useCurrentYearAssumptionSetting = () => {
  const queryInfo = useCurrentYearAssumptionsQuery();

  const saveCurrentYearAssumptionMutation = useCurrentYearAssumptionMutation();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const {
      currentYearAssumptions,
      distributionsOptions,
      earningsOptions,
      contributionsOptions,
      taxesOptions,
      defaultCurrentYearAssumptions,
    } = queryInfo.data;

    return {
      currentYearAssumptions,
      defaultCurrentYearAssumptions,
      distributionsOptions: normalizeOptions(distributionsOptions),
      earningsOptions: normalizeOptions(earningsOptions),
      contributionsOptions: normalizeOptions(contributionsOptions),
      taxesOptions: normalizeOptions(taxesOptions),
    };
  }, [queryInfo]);

  return {
    ...queryInfo,
    data,
    action: { saveCurrentYearAssumptionMutation },
  };
};
